import { UserModel } from 'src/Routes/Users/UserModel'
import { UserAction } from './UserModel'

/**
 * updates user data
 */
export const updateUserData = (userData: UserModel): UserAction => {
  return { type: 'UPDATE_USER_DATA', userData }
}
